// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, Input, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Deal } from '@interfaces/deal.interfaces';
import { DdjDocument, DocumentStatus } from '@interfaces/document.interfaces';
import { AppEvent } from '@interfaces/interfaces';
import { Vehicle } from '@interfaces/vehicle.interfaces';
import { DocumentsService } from '@services/documents.service';
import { UserService } from '@services/user.service';
import { takeWhile } from 'rxjs';

@Component({
    selector: 'buyer-vehicle-info-header',
    templateUrl: './buyer-vehicle-info-header.component.html',
    styleUrls: ['./buyer-vehicle-info-header.component.scss'],
})
export class BuyerVehicleInfoHeaderComponent implements OnInit {
    @Input() vehicle: Vehicle;
    @Input() deal: Deal;
    public completeDocuments: DdjDocument[] = [];
    private isComponentAlive = true;
    public value: number = null;
    public totalDocs = 0;
    public isVehicleInfoActive = false;

    constructor(
        private documentsService: DocumentsService,
        private userService: UserService,
        private dialog: MatDialog
    ) {}

    ngOnInit(): void {
        this.determineDocumentStatus();
    }

    private determineDocumentStatus(): void {
        const relevantDocumentStatus = this.userService.user.userId === this.deal.buyer.userId ? DocumentStatus.BuyerQueue : DocumentStatus.CoBuyerQueue;

        this.documentsService
            .docs$()
            .pipe(takeWhile(() => this.isComponentAlive))
            .subscribe((val) => {
                this.completeDocuments = (val || []).filter((doc) => doc.documentStatusId === DocumentStatus.Complete);
                const incompleteDocuments = (val || []).filter((doc) => doc.documentStatusId === relevantDocumentStatus);
                this.totalDocs = this.completeDocuments.length + incompleteDocuments.length;
            });
    }

    public getImage(): string {
        if (!this.vehicle?.vehicleExt?.image && !this.vehicle?.vehicleExt?.images) {
            return this.getMissingImage();
        }

        if (this.vehicle?.vehicleExt?.image) {
            //return this.vehicle?.vehicleExt?.image;
            const image = this.vehicle?.vehicleExt?.image;
            if (image.includes('https') || image.includes('assets/')) {
                return image;
            } else {
                return 'data:image/webp;base64, ' + image;
            }
        }

        return this.vehicle?.vehicleExt?.images?.split(',')[0];
    }

    private getMissingImage(): string {
        return 'assets/img/mysteryVehicle.png';
    }

    public showMissingImage(event: Event) {
        (<HTMLImageElement>event.target).src = this.getMissingImage();
    }

    modalToggle() {
        this.isVehicleInfoActive = !this.isVehicleInfoActive;
    }
}
